import { render, staticRenderFns } from "./Verkaufspreisanalyse.vue?vue&type=template&id=fe8a444a&"
import script from "./Verkaufspreisanalyse.vue?vue&type=script&lang=js&"
export * from "./Verkaufspreisanalyse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports